import React from "react";

// Style \\
import "../../assets/styles/sections/colculationHero.scss";

const ColculationHero = () => {
  return (
    <section className="colculationHero">
      <div className="colculationHero_bg">
        <div className="containers">
          <div className="colculationHero_items">
            <div className="colculationHero_items_title">
              <p>Home / Product Colculation</p>
              <h2>Product Colculation</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ColculationHero;
